"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

/**
 * Radial progress bar. Pass in 'score' prop (0 -> 100) to set the
 * value of the progress bar. Any 'children' HTML will be put inside the
 * radial.
 */
var RadialProgressBar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RadialProgressBar, _React$Component);

  function RadialProgressBar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RadialProgressBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RadialProgressBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.alignProgressBar = function (score) {
      var changeTrasformRotateZ = function changeTrasformRotateZ(element, deg) {
        (0, _reactDom.findDOMNode)(element).style.transform = "rotateZ(" + deg + "deg)";
        (0, _reactDom.findDOMNode)(element).style.webkitTransform = "rotateZ(" + deg + "deg)";
      };

      if (score <= 66) {
        var leftDeg = -Math.abs(180 - Math.round(2.7 * score)); // No need to move the right, only the left

        changeTrasformRotateZ(_this.refs.leftSectionWedge, leftDeg);
        changeTrasformRotateZ(_this.refs.markerEnd, leftDeg);
      } else {
        // Bring the left section up to full
        changeTrasformRotateZ(_this.refs.leftSectionWedge, 0);
        var rightDeg = -90 - (100 - score) * 2.7; // Move the right section

        changeTrasformRotateZ(_this.refs.rightSectionWedge, rightDeg);
        changeTrasformRotateZ(_this.refs.markerEnd, 180 + rightDeg);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(RadialProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var score = parseInt(this.props.score, 10);
      this.alignProgressBar(score);
    }
    /**
     * Align the progress bar with the score prop passed in.
     */

  }, {
    key: "render",

    /**
     * Change the transform prop of the element, rotating the Z axis.
     */
    value: function render() {
      return _react.default.createElement("div", {
        className: "radial-container",
        "data-reagan-selector": "radial-container"
      }, _react.default.createElement("div", {
        className: "radial-wrapper"
      }, _react.default.createElement("div", {
        className: "radial-section radial-right-section"
      }, _react.default.createElement("div", {
        className: "wedge"
      })), _react.default.createElement("div", {
        className: "radial-section radial-left-section"
      }, _react.default.createElement("div", {
        className: "wedge"
      })), _react.default.createElement("div", {
        className: "marker start"
      }), _react.default.createElement("div", {
        className: "marker end"
      })), _react.default.createElement("div", {
        className: "radial-wrapper radial-progress-wrapper"
      }, _react.default.createElement("div", {
        className: "radial-section radial-right-section"
      }, _react.default.createElement("div", {
        className: "wedge",
        ref: "rightSectionWedge"
      })), _react.default.createElement("div", {
        className: "radial-section radial-left-section"
      }, _react.default.createElement("div", {
        className: "wedge",
        ref: "leftSectionWedge"
      })), _react.default.createElement("div", {
        className: "marker start"
      }), _react.default.createElement("div", {
        className: "marker end",
        ref: "markerEnd"
      }), _react.default.createElement("div", {
        className: "radial-inner-container"
      }, this.props.children)));
    }
  }]);
  return RadialProgressBar;
}(_react.default.Component);

exports.default = RadialProgressBar;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/RadialProgressBar.js
// module id = 151
// module chunks = 0